<template>
  <div>
    <v-layout wrap>
      <v-flex xs6>
        <div v-if="DHCP != null" style="padding: 0 50px">
          Red: <b>{{network}}</b><br>
          Nombre: <b>{{name}}</b><br>
          Grupo: <b>{{group}}</b><br>
          <br>
          DHCP: <b>{{DHCP ? 'SI' : 'NO'}}</b><br>
          Usa proxy: <b>{{isProxy ? 'SI' : 'NO'}}</b><br>
          Proxy: <b>{{proxy}}</b><br>
          Wireless: <b>{{wireless ? 'SI' : 'NO'}}</b><br>
          StaticIPAddress: <b>{{staticIPAddress}}</b><br>
          SubnetMask: <b>{{subnetMask}}</b><br>
          Gateway: <b>{{gateway}}</b><br>
          dns1: <b>{{dns1}}</b><br>
          dns2: <b>{{dns2}}</b><br>
          dns3: <b>{{dns3}}</b><br>
          <br><br>
        </div>
      </v-flex>
      <v-flex xs6 style="padding: 200px 0">
        <v-btn @click="handleChangeConfig">
          Cambiar configuración
        </v-btn>
      </v-flex>
    </v-layout>
    <!-- <div>check-files</div> -->
    <div id="main" @dragover.prevent @drop.prevent>
      <div class="container" @dragleave="fileDragOut" @dragover="fileDragIn" @drop="handleFileDrop" v-bind:style="{ 'background-color': color }">
        Añade tu archivo aquí:
        <br>
        <div class="file-wrapper">
          <input type="file" name="file-input" multiple="True" @change="handleFileInput" > Click o arrastra para añadir el archivo.
        </div>
        <ul>
          <li v-for="(file, index) in files" :key="index">
            {{ file.name }} ({{ file.size }} b)
            <button @click="removeFile(index)" title="Remove">X</button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import JSZip from 'jszip'
  export default {
    components: {
    },
    data () {
      return {
        files: [],
        color: '#444444',

        DHCP: null,
        isProxy: null,
        proxy: null,
        wireless: null,
        staticIPAddress: null,
        subnetMask: null,
        gateway: null,
        dns1: null,
        dns2: null,
        dns3: null,
        network: null,
        name: null,
        group: null,
      }
    },
    methods: {
      ifFile(value) {
        return calue.indexOf('.')>0 ? true : false
      },
      handleChangeConfig() {
        alert('test')
      },
      readFile(xml) {
        console.log(xml)
        this.DHCP = this.checkXml(xml, 'useDHCP') === 'yes' ? true : false
        this.isProxy = this.checkXml(xml, 'useProxy') === 'yes' ? true : false
        this.proxy = this.checkXml(xml, 'proxy')
        this.wireless = this.checkXml(xml, 'useWireless') === 'yes' ? true : false
        this.staticIPAddress = this.checkXml(xml, 'staticIPAddress')
        this.subnetMask = this.checkXml(xml, 'subnetMask')
        this.gateway = this.checkXml(xml, 'gateway')
        this.dns1 = this.checkXml(xml, 'dns1')
        this.dns2 = this.checkXml(xml, 'dns2')
        this.dns3 = this.checkXml(xml, 'dns3')
        this.network = this.checkXml(xml, 'account')
        this.name = this.checkXml(xml, 'unitName')
        this.group = this.checkXml(xml, 'group')
      },
      checkXml(xml, tag) {
        let aux = xml.split(`${tag}>`)
        if (aux.length !== 3) return ''
        else return aux[1].replace('</','')
      },
      getFileZip(files) {
        for (var i = 0, f; f = files[i]; i++) {
          console.log(f.name)
          const that = this
          if (f.name.toUpperCase().indexOf('.ZIP') >= 0) {
            console.log('yes')
            var new_zip = new JSZip()
            // more files !
            new_zip.loadAsync(f)
            .then(function(zip) {
              zip.file("current-sync.xml").async("string").then(function (data) {
                // console.log(data)
                that.readFile(data)
                // data is Uint8Array { 0=72, 1=101, 2=108, more...}
              })
              // console.log(zip.file("autorun.brs").async("string"))
              // that.readFile(zip.file("autorun.brs"))
                // // you now have every files contained in the loaded zip
                // zip.file("hello.txt").async("string"); // a promise of "Hello World\n"
            })
          }          
        }
      },
      handleFileDrop(e) {
        let droppedFiles = e.dataTransfer.files
        if(!droppedFiles) return
        // this tip, convert FileList to array, credit: https://www.smashingmagazine.com/2018/01/drag-drop-file-uploader-vanilla-js/
        ([...droppedFiles]).forEach(f => {
          this.files.push(f)
        })
        console.log('jhm', this.files)
        this.color="#444444"
        this.getFileZip(this.files)        
      },
      handleFileInput(e) {
        let files = e.target.files;
        files = e.target.files
              if(!files) return;
        // this tip, convert FileList to array, credit: https://www.smashingmagazine.com/2018/01/drag-drop-file-uploader-vanilla-js/
        ([...files]).forEach(f => {
      
      this.files.push(f);
        });
      },
      removeFile(fileKey){
        this.files.splice(fileKey, 1)
      },
      fileDragIn(){
        // alert("oof")
        // alert("color")
        this.color="white"
      },
      fileDragOut(){
        this.color="#444444"
      }
    }
  }
</script>
<style>
  body,html{
    height: 100%;
  }
  main {
    margin-top: 30px;
    height: 100%;
  }
  .container {
    border: 2px dashed pink;
    min-height: 150px;
  }
  #main {
    /* border: 1px solid yellow; */
    height: 100vh;
  }
  .file-wrapper {
    text-align: center;
    width: 300px;
    height: 5em;
    vertical-align: middle;
    display: table-cell;
    position: relative;
    overflow: hidden;
    background: gray; /* and other things to make it pretty */
  }


  .file-wrapper input {
      position: absolute;
      top: 0;
      right: 0; /* not left, because only the right part of the input seems to
                  be clickable in some browser I can't remember */
      cursor: pointer;
      opacity: 0.0;
      filter: alpha(opacity=0); /* and all the other old opacity stuff you
                                  want to support */
      font-size: 300px; /* wtf, but apparently the most reliable way to make
                          a large part of the input clickable in most browsers */
      height: 200px;
  }
</style>
